import BaseModulePlugins from '@/store/baseModule/plugins';

export default (store) => {
  const basePlugin = new BaseModulePlugins({
    paramId: 'actionId',
    module: 'actions',
    store,
  });
  basePlugin.onInit(() => {
    basePlugin.persistVuexMutationsToLocalStorage([
      'SET_ATTRIBUTES_OBJ',
      'SET_ITEMS_SORT_BY',
      'SET_VIEW_TABLE',
      'SET_ORDER_ASC',
    ]);

    store.subscribe((mutation) => {
      if (mutation.type === 'entities/SET_CURRENT') {
        store.dispatch(`actions/setFilterAttribute`, {
          attribute: 'author_id',
          values: [],
          useDelay: true,
        });
        store.dispatch(`actions/setFilterAttribute`, {
          attribute: 'staffs_in_charge_id',
          values: [],
          useDelay: true,
        });
        store.dispatch(`actions/setGlobalSearch`, null);
      }
    });

    basePlugin.addItemsToAttributesObjRefWhenTheyAreLoaded({
      serverSide: true,
      autocomplete: true,
      attribute: 'current_action_status_type_id',
      filter: 'actions/status',
    });

    basePlugin.addItemsToAttributesObjRefWhenTheyAreLoaded({
      serverSide: true,
      autocomplete: true,
      attribute: 'type_id',
      filter: 'actions/types',
    });
    basePlugin.addItemsToAttributesObjRefWhenTheyAreLoaded({
      serverSide: true,
      autocomplete: true,
      attribute: 'priority_id',
      filter: 'actions/priorities',
    });

    basePlugin.initAttributeFiltersWhenAttributesObjRefIsLoaded({
      loadingAttributes: [
        'current_action_status_type_id',
        'type_id',
        'priority_id',
      ],
    });
  });
};
